// Design tokens for AeroChat — the single source of truth for colors,
// typography, spacing, and motion. Keep this file framework-agnostic so
// we can consume it from MUI, CSS, and raw canvas drawing code.

export const colors = {
  // Base surface stack — deep navy that reads as black but feels richer
  bg: '#0A0E1A',
  bgSubtle: '#0E1322',
  surface: '#121826',
  surfaceElevated: '#1A2232',
  surfaceHigh: '#232C40',

  // Borders / dividers
  border: 'rgba(255, 255, 255, 0.08)',
  borderStrong: 'rgba(255, 255, 255, 0.14)',
  borderFocus: 'rgba(106, 255, 69, 0.5)',

  // Text
  text: '#E4E9F2',
  textMuted: '#8B95A8',
  textFaint: '#5A647A',
  textInverse: '#0A0E1A',

  // Brand — keep neon green but use as accent, not everywhere
  brand: '#6AFF45',
  brandBright: '#8DFF6E',
  brandDim: '#4CCC30',
  brandShadow: 'rgba(106, 255, 69, 0.35)',

  // Data viz secondary — electric cyan for variety
  data: '#00D9FF',
  dataDim: '#0099B5',

  // Semantic
  success: '#6AFF45',
  warning: '#FFB547',
  danger: '#FF4757',
  info: '#00D9FF',

  // Gradients
  gradBrand: 'linear-gradient(135deg, #6AFF45 0%, #8DFF6E 100%)',
  gradData: 'linear-gradient(135deg, #00D9FF 0%, #6AFF45 100%)',
  gradSurface:
    'linear-gradient(180deg, rgba(26, 34, 50, 0.8) 0%, rgba(18, 24, 38, 0.8) 100%)',
  gradHero:
    'radial-gradient(ellipse at top, rgba(106, 255, 69, 0.15) 0%, transparent 60%), radial-gradient(ellipse at bottom right, rgba(0, 217, 255, 0.1) 0%, transparent 50%)',
};

export const typography = {
  fontFamilyUi:
    '"Inter", -apple-system, "Helvetica Neue", Arial, sans-serif',
  fontFamilyMono:
    '"JetBrains Mono", "SF Mono", Menlo, Consolas, monospace',
};

export const spacing = {
  // 4px baseline grid
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
};

export const radius = {
  sm: 6,
  md: 10,
  lg: 14,
  xl: 20,
  pill: 999,
};

export const shadows = {
  none: 'none',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.5)',
  md: '0 4px 12px 0 rgba(0, 0, 0, 0.35), 0 1px 2px 0 rgba(0, 0, 0, 0.2)',
  lg: '0 12px 32px 0 rgba(0, 0, 0, 0.5), 0 4px 8px 0 rgba(0, 0, 0, 0.3)',
  xl: '0 24px 48px 0 rgba(0, 0, 0, 0.55)',
  brandGlow:
    '0 0 0 1px rgba(106, 255, 69, 0.3), 0 8px 32px 0 rgba(106, 255, 69, 0.2)',
  brandGlowStrong:
    '0 0 0 1px rgba(106, 255, 69, 0.5), 0 12px 48px 0 rgba(106, 255, 69, 0.35)',
};

export const motion = {
  durationFast: '120ms',
  durationMed: '220ms',
  durationSlow: '400ms',
  easingStandard: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
  easingAccelerate: 'cubic-bezier(0.4, 0, 1, 1)',
  easingDecelerate: 'cubic-bezier(0, 0, 0.2, 1)',
};
